export const FETCH_ORGANIZATIONS_SUCCESS = 'FETCH_ORGANIZATIONS_SUCCESS';
export const FETCHING_ORGANIZATIONS = 'FETCHING_ORGANIZATIONS';
export const CREATING_ORGANIZATION = 'CREATING_ORGANIZATION';
export const CREATE_ORGANIZATION_SUCCESS = 'CREATE_ORGANIZATION_SUCCESS';
export const CREATE_ORGANIZATION_FAILURE = 'CREATE_ORGANIZATION_FAILURE';
export const FETCH_ORGANIZATION = 'FETCH_ORGANIZATION';
export const FETCH_ORGANIZATION_FAILURE = 'FETCH_ORGANIZATION_FAILURE';
export const FETCHING_ORGANIZATION = 'FETCHING_ORGANIZATION';
export const UPDATE_ORGANIZATION_SUCCESS = 'UPDATE_ORGANIZATION_SUCCESS';
export const UPDATING_ORGANIZATION = 'UPDATING_ORGANIZATION';
export const SAVING_ORGANIZATION = 'SAVING_ORGANIZATION';
export const SAVE_ORGANIZATION_SUCCESS = 'SAVE_ORGANIZATION_SUCCESS';
export const SAVE_ORGANIZATION_FAILURE = 'SAVE_ORGANIZATION_FAILURE';
export const CLEAR_ORGANIZATION_FLAG = 'CLEAR_ORGANIZATION_FLAG';




// WEBPACK FOOTER //
// ./src/redux/organizations/OrganizationsConstants.js